import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'pydantic2',
    title: 'Pydantic2',
    description: 'A powerful AI framework with structured Pydantic response handling, LLM integration, and advanced agent capabilities.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'Python',
            'Pydantic',
            'LiteLLM',
            'Instructor',
            'OpenRouter',
            'SmoLAgents',
            'Django',
            'FastAPI',
        ],
        url: 'https://pydantic.unrealos.com',
        github: 'https://github.com/markolofsen/pydantic2',
        pypi: 'https://pypi.org/project/pydantic2/',
    },
};

export default data;
